module.exports = __webpack_public_path__ + "img/45exp.c364cda3.jpg";